import { SVGProps } from 'react'

type Props = SVGProps<SVGSVGElement>

export const HashTagIconComponent = (props: Props) => {
  return (
    <svg
      width={28}
      height={28}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={28} height={28} rx={14} fill="#0F1728" />
      <path
        d="M13.6917 22L16.2039 6H19.1044L16.5922 22H13.6917ZM7 18.1371L7.41109 15.2571H20.2463L19.8352 18.1371H7ZM9.00979 22L11.522 6H14.4225L11.9103 22H9.00979ZM7.63948 13.4743L8.16476 10.5714H21L20.4747 13.4743H7.63948Z"
        fill="white"
      />
    </svg>
  )
}

export const HashTagIcon = HashTagIconComponent
